import {
  Box,
  Paper,
  Table,
  TableBody,
  useMediaQuery,
  useTheme
} from "@material-ui/core";
import { CustomLineProgress } from "components/LineProgress";
import { useMemo, useState } from "react";

import {
  BodyCell,
  BodyRow,
  HeadCell,
  HeadSortLabel,
  MobileCard,
  MobileCardHeader,
  MobileCardId,
  MobileCardLabel,
  MobileCardList,
  MobileCardName,
  MobileCardRow,
  MobileCardValue,
  StyledTableHead,
  TableContent
} from "../../styles";

const SORT_FIELD_BY_COLUMN = {
  current: "currentSummary",
  future: "futureSummary"
};

export const StorageTable = ({ storageOutOfStock, loading }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const [sort, setSort] = useState({ column: "current", direction: "asc" });

  const handleSort = column => {
    setSort(current => ({
      column,
      direction:
        current.column === column && current.direction === "asc"
          ? "desc"
          : "asc"
    }));
  };

  const sortedStorageOutOfStock = useMemo(() => {
    const field = SORT_FIELD_BY_COLUMN[sort.column];
    const directionMultiplier = sort.direction === "asc" ? 1 : -1;

    return [...(storageOutOfStock || [])].sort((a, b) => {
      const diff = (a[field] ?? 0) - (b[field] ?? 0);
      if (diff !== 0) {
        return diff * directionMultiplier;
      }
      return a.product_base_name.localeCompare(b.product_base_name);
    });
  }, [storageOutOfStock, sort]);

  if (isMobile) {
    return (
      <Box style={{ display: "flex", flexDirection: "column", flex: 1 }}>
        {!!loading && <CustomLineProgress />}
        <TableContent
          component={Paper}
          style={{
            border: "none",
            boxShadow: "none",
            background: "transparent"
          }}
        >
          <MobileCardList>
            {sortedStorageOutOfStock?.map(storage => (
              <MobileCard key={storage.product_base_id}>
                <MobileCardHeader>
                  <MobileCardName>{storage.product_base_name}</MobileCardName>
                  <MobileCardId>#{storage.product_base_id}</MobileCardId>
                </MobileCardHeader>
                <MobileCardRow>
                  <MobileCardLabel>Saldo atual</MobileCardLabel>
                  <MobileCardValue
                    style={{
                      color: storage.currentSummary < 0 ? "#EB001B" : undefined
                    }}
                  >
                    {storage.currentQuantity}
                  </MobileCardValue>
                </MobileCardRow>
                <MobileCardRow>
                  <MobileCardLabel>Saldo futuro</MobileCardLabel>
                  <MobileCardValue
                    style={{
                      color: storage.futureSummary < 0 ? "#EB001B" : undefined
                    }}
                  >
                    {storage.futureQuantity}
                  </MobileCardValue>
                </MobileCardRow>
              </MobileCard>
            ))}
          </MobileCardList>
        </TableContent>
      </Box>
    );
  }

  return (
    <Box style={{ display: "flex", flexDirection: "column", flex: 1 }}>
      {!!loading && <CustomLineProgress />}
      <TableContent component={Paper}>
        <Table stickyHeader>
          <StyledTableHead>
            <HeadCell>ID</HeadCell>
            <HeadCell>Produto</HeadCell>
            <HeadCell
              sortDirection={sort.column === "current" ? sort.direction : false}
            >
              <HeadSortLabel
                active={sort.column === "current"}
                direction={sort.column === "current" ? sort.direction : "asc"}
                onClick={() => handleSort("current")}
              >
                Saldo atual
              </HeadSortLabel>
            </HeadCell>
            <HeadCell
              sortDirection={sort.column === "future" ? sort.direction : false}
            >
              <HeadSortLabel
                active={sort.column === "future"}
                direction={sort.column === "future" ? sort.direction : "asc"}
                onClick={() => handleSort("future")}
              >
                Saldo futuro
              </HeadSortLabel>
            </HeadCell>
          </StyledTableHead>
          <TableBody>
            {sortedStorageOutOfStock?.map(storage => {
              return (
                <BodyRow key={storage.product_base_id}>
                  <BodyCell>{storage.product_base_id}</BodyCell>
                  <BodyCell style={{ fontWeight: 500 }}>
                    {storage.product_base_name}
                  </BodyCell>
                  <BodyCell
                    style={{ color: storage.currentSummary < 0 && "#EB001B" }}
                  >
                    {storage.currentQuantity}
                  </BodyCell>
                  <BodyCell
                    style={{ color: storage.futureSummary < 0 && "#EB001B" }}
                  >
                    {storage.futureQuantity}
                  </BodyCell>
                </BodyRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContent>
    </Box>
  );
};
